import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, useTranslation } from '@pascal/pascal-core';
import { ODD_CHANGE_TYPES, WIN_COMBINATIONS_NAMES } from '../../enums/betTypesEnum';
import { MAX_BOX_COUNT } from '../../enums/cardTypes';
import BetChipSection from '../betChipSection';
import { winningAmountStore } from '../../store/winningAmountStore';
import { CurrentBoxCards } from '../currentBoxCards';
import { gameStore } from '../../store/gameStore';

let lastOdd = null;
export const CurrentBoxInfo = observer(({ betType, boxBetTypesInfo, boxIndex, handleDoChip }) => {
  const { winningBoxes, winningCombination } = winningAmountStore;
  const { isBetsClosed } = gameStore;
  const [isChangedOdd, setIsChangedOdd] = useState(false);

  const t = useTranslation();
  const currentBoxInfo = useMemo(() => {
    if (boxBetTypesInfo) {
      let isSlowOdd = null;
      boxBetTypesInfo?.selections.forEach((item) => {
        if (!isSlowOdd || (item.odd >= 1 && item.odd < isSlowOdd)) {
          isSlowOdd = item.odd;
        }
      });
      return {
        ...boxBetTypesInfo?.selections.find((item) => item.marketType === betType),
        isSlowOdd,
      };
    }
    return null;
  }, [boxBetTypesInfo, betType]);

  const oddInBox = useMemo(() => {
    if ((winningBoxes && winningBoxes?.includes(boxIndex)) || currentBoxInfo?.isWin) {
      return 'WIN';
    }
    if (currentBoxInfo && currentBoxInfo.odd > 1 && !winningBoxes) {
      return `x${currentBoxInfo.odd}`;
    }
    return 'LOSE';
  }, [currentBoxInfo, winningBoxes, boxIndex]);

  const handleIsAllowDoChip = useCallback(
    (data) => {
      if (oddInBox === 'WIN' || (currentBoxInfo?.hasOwnProperty('odd') && currentBoxInfo.odd < 1)) {
        return;
      }
      handleDoChip(data);
    },
    [currentBoxInfo, handleDoChip, oddInBox]
  );

  useEffect(() => {
    if ((lastOdd === null || lastOdd !== oddInBox) && Number.isInteger(+oddInBox[1])) {
      lastOdd = oddInBox;
      setIsChangedOdd(true);
      setTimeout(() => {
        setIsChangedOdd(false);
      }, 200);
    }
  }, [oddInBox]);

  return (
    <div className={`bet-on-poker-seat-section seat-${boxIndex}`}>
      <div className={`bet-on-poker-seat-cards to-bottom ${oddInBox === 'LOSE' ? 'disabled' : ''}`}>
        <CurrentBoxCards currentBoxIndex={boxIndex} />
      </div>
      <div
        className={`bet-on-poker-seat ${isBetsClosed ? '' : 'pointer'} ${
          currentBoxInfo?.isSlowOdd === currentBoxInfo?.odd && winningCombination === null
            ? 'shining-seat'
            : ''
        } ${currentBoxInfo?.hasOwnProperty('odd') && currentBoxInfo.odd < 1 ? 'lose' : ''} ${
          // eslint-disable-next-line
          !winningBoxes && !currentBoxInfo?.isWin
            ? ''
            : (winningBoxes && winningBoxes?.includes(boxIndex)) || currentBoxInfo?.isWin
            ? 'win'
            : 'lose'
        }`}
        onClick={() => handleIsAllowDoChip({ betType })}
      >
        {boxIndex > MAX_BOX_COUNT / 2 && <BetChipSection isInBoxSection betType={betType} />}
        <div className='bet-on-poker-seat-info'>
          <div className='bet-on-poker-seat-info-row'>
            {/* add class // to-bottom-txt // for bet-on-poker-seat-x //state-small */}
            <p
              className={`bet-on-poker-seat-x ${
                oddInBox.length >= 7 && isMobile() ? 'state-small' : ''
              } ${isChangedOdd ? 'to-bottom-txt' : ''} ${
                currentBoxInfo?.oddChange === ODD_CHANGE_TYPES.over &&
                oddInBox !== 'WIN' &&
                oddInBox !== 'LOSE'
                  ? 'win-up'
                  : ''
              } ${
                currentBoxInfo?.oddChange === ODD_CHANGE_TYPES.under &&
                oddInBox !== 'LOSE' &&
                oddInBox !== 'WIN'
                  ? 'lose-down'
                  : ''
              } ${oddInBox === 'WIN' ? 'win' : ''}`}
            >
              {t(oddInBox)}
            </p>
            <div className='bet-on-poker-seat-arrows'>
              <div className='bet-on-poker-seat-arrow'>
                <i className='icon-lose-down' />
              </div>
              <div className='bet-on-poker-seat-arrow'>
                <i className='icon-lose-down' />
              </div>
              <div className='bet-on-poker-seat-arrow'>
                <i className='icon-lose-down' />
              </div>
            </div>
          </div>
          {/* {totalAmount && ( */}
          {/*  <div className='bet-on-poker-seat-info-row'> */}
          {/*    <p className='bet-on-poker-seat-amount active'>{totalAmount}</p> */}
          {/*  </div> */}
          {/* )} */}
        </div>
        {boxIndex <= MAX_BOX_COUNT / 2 && <BetChipSection isInBoxSection betType={betType} />}
      </div>
      {oddInBox === 'WIN' && (
        <div className='bet-on-poker-seat-notify'>
          <p className='bet-on-poker-seat-notify-txt'>
            {t(WIN_COMBINATIONS_NAMES[winningCombination])}
          </p>
        </div>
      )}
    </div>
  );
});
